// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ec5b8c2e","295":"8a719e85","355":"0bb07127","357":"01aff4cb","434":"59c2b186","462":"64bfe6e4","512":"81c17611"}[chunkId] + ".chunk.js";
};